import { Footer } from 'components/Footer'
import { Header } from 'components/Header'
import { Layout } from 'components/Layout'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { Icon } from 'components/Icon'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'
import { ContactOptionsSection, TitleSection, Wrapper } from './ContactUs.styles'
import { IconName } from 'components/Icon/iconNames'
import Trans from 'next-translate/Trans'
import { Gorgias } from './GorgiasCDN'
import { useEffect, useState } from 'react'

export const ContactUs = () => {
  const { t } = useTranslation()
  const [isReady, setIsReady] = useState(false)

  const router = useRouter()
  const { query } = useRouter()

  const contactOptions = [
    {
      label: 'contact-us:email',
      url: 'mailto:hello@wefeedraw.com',
      icon: 'envelope' as IconName,
    },
    {
      label: 'contact-us:text',
      url: 'sms:+18437322849',
      icon: 'mobile' as IconName,
    },
    {
      label: 'contact-us:call',
      url: 'tel:+18542031608',
      icon: 'phone' as IconName,
    },
  ]

  useEffect(() => {
    if (isReady || typeof window === 'undefined' || !window?.GorgiasChat) return
    var initGorgiasChatPromise = window.GorgiasChat
      ? window.GorgiasChat.init()
      : new Promise<void>(function (resolve) {
          window.addEventListener('gorgias-widget-loaded', function () {
            resolve()
          })
        })
    initGorgiasChatPromise
      .then(() => {
        setIsReady(true)
      })
      .finally(() => {
        if (!isReady) {
          window.GorgiasChat.init()
          setIsReady(true)
        }
      })
  })

  const header = <Header />
  return (
    <Layout header={header} hideCTA>
      <Wrapper>
        <Stack direction="column" gap="5" css={{ width: ' $max' }}>
          <TitleSection>
            <Stack alignItems="center">
              <Text size="h3" as="h3" weight="bold" color="accent-black">
                {t('contact-us:title')}
              </Text>
            </Stack>
            <Stack>
              <Text size="body" color="accent-black">
                <Trans
                  i18nKey="contact-us:subtitle"
                  components={{
                    link: <a href="mailto:hello@wefeedraw.com" />,
                    link2: <a href="sms:+118437322849" />,
                  }}
                />
              </Text>
            </Stack>
          </TitleSection>
          <ContactOptionsSection>
            {isReady && <Gorgias />}
            {contactOptions.map(({ label, url, icon }, index) => (
              <li key={index}>
                <a href={url} aria-label={t(label)} title={label} target="_blank" rel="noreferrer">
                  <Icon size={{ '@initial': '4', '@bp1': '3' }} name={icon} />
                  {t(label)}
                </a>
              </li>
            ))}
          </ContactOptionsSection>
        </Stack>
      </Wrapper>
      <Footer />
    </Layout>
  )
}

ContactUs.displayName = 'ContactUs'
